





































































































import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
} from '@vue/composition-api';
import { useConfirmDialog } from '@vueuse/core';
import ConfirmationModal from '@front-app/components/modals/ConfirmationModal.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import TrCheckbox from '@front-app/components/inputs/Checkbox.vue';
import TrForm from '@front-app/components/form/Form.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import {
	changeGroupRole,
	GroupRoleNotExternal,
	GroupsListItem,
	GROUP_ROLE_LABELS,
	UpdateUserGroupRolesRequest,
} from '@front-app/services/CommunityApi/CommunityReportsApi';
import { DropdownPosition } from '@front-app/components/dropdowns/dropdownPosition';
import { Size } from '@front-app/components/constants';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';

const GROUP_ROLES: GroupRoleNotExternal[] = [
	UserRole.MEMBER,
	UserRole.ADMINISTRATOR,
	UserRole.MODERATOR,
	UserRole.INVITEE,
	UserRole.DEPARTEE,
];

export default defineComponent({
	components: {
		ConfirmationModal,
		CtaButton,
		ErrorCard,
		RadioButton,
		SlidingPanel,
		SuccessCard,
		TrCheckbox,
		TrForm,
	},
	props: {
		preSelectedGroups: {
			type: Array as PropType<GroupsListItem[]>,
			required: true,
		},
		preSelectedGroupsByRole: {
			type: Object as PropType<Record<string, GroupsListItem[]>>,
			required: true,
		},
		userIds: {
			type: Array as PropType<string[]>,
			required: true,
		},
	},
	setup(props, ctx) {
		// Groups by role for single user
		const groupsByRole = computed(() => Object.keys(props.preSelectedGroupsByRole)
			.sort((a, b) => a.localeCompare(b))
			.map((groupRole) => ({
				groupRole,
				groups: props.preSelectedGroupsByRole[groupRole],
			})));

		const selectedGroupIds = ref([] as string[]);
		const toggleGroup = (groupId: string) => {
			if (selectedGroupIds.value.includes(groupId)) {
				selectedGroupIds.value = selectedGroupIds.value.filter((selectedGroupId) => selectedGroupId !== groupId);
			} else {
				selectedGroupIds.value = selectedGroupIds.value.concat(groupId);
			}
		};

		const groupRoles = computed(() => GROUP_ROLES
			.map((groupRole) => ({
				key: groupRole,
				label: ctx.root.$t(GROUP_ROLE_LABELS[groupRole]) as unknown as string,
			})));
		const selectedGroupRole: Ref<UserRole> = ref(UserRole.MEMBER);

		// Submission
		const changeGroupRoleConfirmation = useConfirmDialog();
		const {
			clear,
			isError,
			isLoading,
			isSuccess,
			track,
		} = useAsyncStatus();
		const updateGroupRole = async () => {
			const { isCanceled } = await changeGroupRoleConfirmation.reveal();
			if (isCanceled) {
				return;
			}
			const payload: UpdateUserGroupRolesRequest = {
				userIds: props.userIds,
				groupIds: selectedGroupIds.value,
				role: selectedGroupRole.value,
			};
			await track(changeGroupRole(payload));
		};
		const clearAndClose = () => {
			ctx.emit('close');
			clear(0);
			selectedGroupIds.value = [];
			selectedGroupRole.value = UserRole.MEMBER;
		};

		return {
			groupsByRole,
			selectedGroupIds,
			toggleGroup,
			groupRoles,
			GROUP_ROLE_LABELS,
			selectedGroupRole,
			changeGroupRoleConfirmation,
			updateGroupRole,
			isError,
			isLoading,
			isSuccess,
			clearAndClose,
			// Util
			ButtonPalettes,
			DropdownPosition,
			Size,
		};
	},
});
